import { render, staticRenderFns } from "./UserRowPermission.vue?vue&type=template&id=02745652&scoped=true&"
import script from "./UserRowPermission.vue?vue&type=script&lang=ts&"
export * from "./UserRowPermission.vue?vue&type=script&lang=ts&"
import style0 from "./UserRowPermission.vue?vue&type=style&index=0&id=02745652&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02745652",
  null
  
)

export default component.exports